import React, { useState, useEffect } from 'react';
import { siteConfigAPI } from '../services/api';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [whatsapp, setWhatsapp] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    siteConfigAPI.get().then((cfg) => setWhatsapp(cfg?.whatsapp)).catch(() => {});
  }, []);

  const handleClick = () => {
    if (!whatsapp) return;
    window.open(`https://wa.me/${whatsapp}?text=Hello%2C%20I%20want%20to%20contact%20you`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className={`fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={32} />
    </button>
  );
};

export default WhatsAppButton;
